import { React, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CompetencesAndSkills from "../components/CompetencesAndSkills";
import Language from "../components/Language";
import TechSkills from "../components/PersonalSkillsAndCompetences";
import OtherCompetences from "../components/OtherSkills";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { CommonService } from "../../../../services/CommonService";
import { ValidateFields } from "../ValidateFields";
import { Row } from "react-bootstrap";

export function Competences({ cardStatus, changeCardStatus }) {
  const { t } = useTranslation();
  const {
    searchObject,
    setSearchObject,
    onChange,
    errors
  } = useAdvanceSearchContext();
  const [personalSkills, setpersonalSkills] = useState([]);

  function clearCompetence() {
    searchObject.languageLevels = [];
    searchObject.otherSkills = undefined;
    searchObject.skills = [];
    searchObject.languageId = undefined;

    if (personalSkills && personalSkills.length > 0) {
      let _personnalSkills = personalSkills.map((skill) => {
        if (skill.rating !== "") {
          return {
            description: skill.description,
            id: skill.id,
            rating: 0
          };
        }
      });

      setSearchObject({
        ...searchObject,
        personalSkills: _personnalSkills
      });
    }
  }

  useEffect(
    () => CommonService.getAllSkills().then((data) => setpersonalSkills(data)),
    []
  );

  return (
    <>
      <div className="accordion-item border-accordion">
        <h2
          className="accordion-header margin-accordion"
          id="headingCompetence"
        >
          <button
            className={`accordion-button border-accordion-button ${
              cardStatus ? "" : "collapsed heding-bold"
            }`}
            type="button"
            data-bs-target="#collapseCvs"
            aria-expanded="true"
            aria-controls="collapseCvs"
            onClick={changeCardStatus}
            id="accordionCompetence"
          >
            {`${t("Skills")} ${ValidateFields.competence(searchObject)}`}
          </button>
        </h2>
        <div
          id="accordionInputs"
          className={`accordion-collapse ${cardStatus ? "" : "collapse"}`}
          aria-labelledby="headingCompetence"
          data-bs-parent="#accordionFlushDocuments"
        >
          <div className="accordion-body table-wrap ">
            <div>
              <Language
                searchObject={searchObject}
                setSearchObject={setSearchObject}
                onChange={onChange}
                t={t}
                errors={errors}
              />
            </div>
            <Row className="margin-between-lables">
              <div className="col-md-6">
                <CompetencesAndSkills
                  searchObject={searchObject}
                  t={t}
                  setSearchObject={setSearchObject}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-6">
                <TechSkills
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row style={{ marginTop: "30px" }}>
              <div className="col-md-6">
                <OtherCompetences
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
          </div>
          <div className="text-end button-clear-position">
            <button
              className="app-button btn-second btn-md"
              onClick={clearCompetence}
            >
              {t("Clear Competences")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
